module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-ticket-statistic/event-ticket-statistic.component.scss
// module id = ./src/app/routes/event/event-ticket-statistic/event-ticket-statistic.component.scss
// module chunks = 9